import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { store } from './store';
import './styles/globals.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Footer from './components/Footer/Footer';
import Quiz from './components/Quiz/Quiz';
import QuizPage from './components/Quiz/QuizPage';
import ReportPage from './components/Report/ReportPage';
import ContactPage from './pages/ContactPage';
import LegalPage from './pages/LegalPage';
import WhatsAppPlugin from './components/Whatsapp/WhatsAppPlugin';
import ShopPage from './pages/ShopPage';
import LandingPage from './pages/LandingPage';
import ENTPage from './pages/ENTPage';


import './App.css';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="App">
          <Routes>
            {/* <Route path="/" element={
              <>
                <Header />
                <Hero />
                <Quiz />
                <Footer />
              </>
            } /> */}
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/skin-quiz" element={<QuizPage />} />
            <Route path="/report" element={<ReportPage />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/ent" element={<ENTPage />} />
          </Routes>
          
          {/* WhatsApp plugin - will appear on all pages */}
          {/* <WhatsAppPlugin /> */}
        </div>
      </Router>
    </Provider>
  );
}

export default App;